import React, {useCallback, useContext, useEffect} from 'react';
import CommandsContext from '../../../context/commandsContext';
import useKeyPress from '../../../hooks/useKeyPress';
import {useMenu} from '../../../hooks/useMenu';
import BodyContentView from '../../views/bodyContentView';
import SmartMeterPB from './smart-meterPB';
import SMVComplete from './smv-complete';

function AbortSMV({onExit}) {
  const leftPress = useKeyPress('ArrowLeft');
  const rightPress = useKeyPress('ArrowRight');
  const {selected, onComponent} = useMenu();
  const {onUpdateCommands} = useContext(CommandsContext);

  const onLeft = useCallback(() => {
    onComponent(<SmartMeterPB />);
  }, []);

  const onRight = useCallback(() => {
    onComponent(<SMVComplete />);
  }, []);

  useEffect(() => {
    if (!leftPress) return;

    onLeft();
  }, [leftPress]);

  useEffect(() => {
    if (!rightPress) return;

    onRight();
  }, [rightPress]);

  useEffect(() => {
    onUpdateCommands({onLeft, onRight});
  }, [onLeft, onRight]);

  return (
    <BodyContentView
      title="Abort SMV"
      left="No"
      right="Yes"
      caption="Are you sure you want to abort Meter Verification?"
    />
  );
}

export default AbortSMV;
